import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import axios from 'axios';
import { Box, Modal, IconButton, Fade } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const PublicidadHome = () => {
  const [events, setEvents] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // Traer imágenes desde Laravel
  useEffect(() => {
    axios.get('https://turismosanroman.com/turismobackend/public/api/publicidads')
      .then(response => setEvents(response.data))
      .catch(error => console.error('Error al obtener publicidads:', error));
  }, []);

  const handleOpenModal = (image) => {
    setSelectedImage(image);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedImage(null);
  };

  if (events.length === 0) return null;

const imageStyle = {
  width: 'auto',              // Ancho automático según proporción
  maxWidth: 600,              // Máximo ancho para desktop
  maxHeight: 250,             // Altura máxima
  objectFit: 'contain',       // Mostrar toda la imagen sin recortarla
  display: 'block',           // Para poder centrar con margin
  margin: '0 auto',           // Centrado horizontal
  borderRadius: 4,
  cursor: 'pointer',
  transition: 'transform 0.3s ease',
  '&:hover': { transform: 'scale(1.05)' }
};

  const sliderSettings = {
    dots: true,
    infinite: events.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: events.length > 1,
    autoplaySpeed: 4000,
    appendDots: dots => (
      <Box sx={{ mt: 2 }}>
        <ul style={{ margin: 0, padding: 0, display: 'flex', justifyContent: 'center', gap: '8px' }}>
          {dots}
        </ul>
      </Box>
    ),
    customPaging: i => (
      <Box sx={{ width: 10, height: 10, bgcolor: '#1976d2', borderRadius: '50%' }} />
    )
  };

  return (
    <>
      {/* Contenedor principal */}
      <Box
        sx={{
          p: 2,
          pb: 4,
          backgroundColor: '#ffffff',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          borderRadius: 3
        }}
      >
        {events.length === 1 ? (
          <Box
            sx={{ textAlign: 'center' }}
            onClick={() => handleOpenModal(events[0].imagen)}
          >
            <Box
              component="img"
              src={events[0].imagen}
              alt="Evento único"
              sx={imageStyle}
            />
          </Box>
        ) : (
          <Slider {...sliderSettings}>
            {events.map(event => (
              <Box
                key={event.id}
                onClick={() => handleOpenModal(event.imagen)}
                sx={{ textAlign: 'center' }}
              >
                <Box
                  component="img"
                  src={event.imagen}
                  alt={`Evento ${event.id}`}
                  sx={imageStyle}
                />
              </Box>
            ))}
          </Slider>
        )}
      </Box>

      {/* Modal estilo lightbox */}
      <Modal open={openModal} onClose={handleCloseModal} closeAfterTransition>
        <Fade in={openModal}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              bgcolor: 'rgba(0,0,0,0.9)',
              borderRadius: 2,
              width: '90vw',       // 90% del ancho de la ventana
              height: '90vh',      // 90% de la altura de la ventana
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              p: 1,
              outline: 'none',
              overflow: 'hidden',  // importante: evita que la imagen salga del contenedor
            }}
          >
            <IconButton
              aria-label="Cerrar imagen"
              onClick={handleCloseModal}
              sx={{ position: 'absolute', top: 8, right: 8, color: '#fff', zIndex: 10 }}
            >
              <CloseIcon />
            </IconButton>

            {selectedImage && (
              <Box
                component="img"
                src={selectedImage}
                alt="Evento ampliado"
                sx={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',  // mantiene proporción
                  borderRadius: 2,
                }}
              />
            )}
          </Box>
        </Fade>

      </Modal>
    </>
  );
};

export default PublicidadHome;
